module.exports = __webpack_public_path__ + "static/images/monet/actions_icon.png";